// This icon file is generated automatically.
var PSaveOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M12.96 3.58l-2.54-2.54A1 1 0 0010 .8V.75H1.25a.5.5 0 00-.5.5v11.5c0 .28.22.5.5.5h11.5a.5.5 0 00.5-.5V4.29a1 1 0 00-.3-.7zM5 1.88h4V3.5H5V1.87zm7.13 10.25H1.87V1.87H4V4c0 .28.22.5.5.5h5A.5.5 0 0010 4V2.22l2.13 2.12v7.79zM7 5.9a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5zm0 3.5a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5z", "fill-rule": "nonzero" } }] }, "name": "p-save", "theme": "outlined" };
export default PSaveOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PSaveOutlined.js
// module id = 3612
// module chunks = 0